"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessService = exports.accessService = void 0;
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../../auth-suite-sdk-setup/models");
var check_access_status_context_1 = require("./check-access-status.context");
var checkAccessStatus = function (request) {
    if (request === void 0) { request = {}; }
    var result = check_access_status_context_1.checkAccessStatusContext.checkAccessStatus(request);
    console.log("checkAccessStatus result: ".concat(result));
    return result;
};
var checkAccessStatusForResourceGroup = function (request) { return checkAccessStatus(request); };
var isAuthorized = function (request, predefinedResponse) {
    return predefinedResponse
        ? isResourceGroupAvailable(request.resourceGroup, predefinedResponse)
        : isResourceGroupAvailableForRequest(request);
};
var getAuthorizationMethod = function (request) {
    var path = "access/authorization/".concat(request.resourceGroup);
    var fetchData = { path: path };
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get(fetchData);
};
var getInAppPurchaseAccessMethodsInUse = function (request) {
    if (request === void 0) { request = {}; }
    return checkAccessStatus(request).then(function (response) {
        return filterInAppPurchaseAccessMethods(response.accessMethodsInUse);
    });
};
var filterInAppPurchaseAccessMethods = function (accessMethods) {
    return accessMethods.filter(function (accessMethod) { return accessMethod.type === models_1.ContentAccessMethodType.InAppPurchase; });
};
var isResourceGroupAvailableForRequest = function (request) {
    return checkAccessStatus().then(function (response) {
        return isResourceGroupAvailable(request.resourceGroup, response);
    });
};
var isResourceGroupAvailable = function (resourceGroup, response) {
    console.log("checking availability for resourceGroup: ".concat(resourceGroup, ", and response: ").concat(response));
    var authorizedResources = getAuthorizedResources(resourceGroup, response);
    console.log("authorizedResources are: ".concat(authorizedResources));
    var isResourceGroupInAuthorizedResources = Boolean(authorizedResources.length);
    return Promise.resolve(isResourceGroupInAuthorizedResources);
};
var getAuthorizedResources = function (resourceGroup, response) {
    return response.accessMethodsInUse.filter(function (method) {
        return authorizedResourceIndex(resourceGroup, method.authorizedResourceGroups);
    });
};
var authorizedResourceIndex = function (resourceGroupToFind, authorizedResourceGroups) {
    return authorizedResourceGroups.indexOf(resourceGroupToFind) > -1;
};
exports.accessService = {
    checkAccessStatus: checkAccessStatus,
    checkAccessStatusForResourceGroup: checkAccessStatusForResourceGroup,
    getAuthorizationMethod: getAuthorizationMethod,
    getInAppPurchaseAccessMethodsInUse: getInAppPurchaseAccessMethodsInUse,
    isAuthorized: isAuthorized,
};
var AccessService = /** @class */ (function () {
    function AccessService() {
        return exports.accessService;
    }
    return AccessService;
}());
exports.AccessService = AccessService;
